import { CategoryEditorListener } from "./category-editor/category-editor-listener";
import { CategoryEditorHandler } from "./category-editor/category-editor-handler";
import type { CategoryReviewEditorHandler } from "./category-review-editor-handler";
import { ReviewConfigEditorListener } from "./review-config-editor/review-config-editor-listener";
import { ReviewConfigEditorHandler } from "./review-config-editor/review-config-editor-handler";

type CategoryReviewEditorListenerElements = {
    overlayEl: HTMLElement;
    tabParentEl: HTMLElement;
    tabChildEl: HTMLElement;
    tabReviewEl: HTMLElement;
    panelParentEl: HTMLElement;
    panelChildEl: HTMLElement;
    panelReviewEl: HTMLElement;
    saveBtnEl: HTMLElement;
    addBtnEl: HTMLElement;
    addEntryModalEl: HTMLElement;
    addEntrySubmitBtnEl: HTMLElement;
    addEntryCloseBtnEls: HTMLElement[];
    questionOptionModalEl: HTMLElement;
    questionOptionSubmitBtnEl: HTMLElement;
    questionOptionCloseBtnEls: HTMLElement[];
    reviewSettingsModalEl: HTMLElement;
    reviewSettingsPanelEl: HTMLElement;
    reviewSettingsSaveBtnEl: HTMLElement;
    reviewSettingsAddBtnEl: HTMLElement;
    reviewSettingsCloseBtnEls: HTMLElement[];
    closeBtnEls: HTMLElement[];
    openBtnEls: HTMLElement[];
};

export class CategoryReviewEditorListener {
    private readonly handler: CategoryReviewEditorHandler;

    private readonly elements: CategoryReviewEditorListenerElements;

    private readonly categoryEditorHandler: CategoryEditorHandler;

    private readonly reviewConfigEditorHandler: ReviewConfigEditorHandler;

    private readonly categoryEditorListener: CategoryEditorListener;

    private readonly reviewConfigEditorListener: ReviewConfigEditorListener;

    public constructor(handler: CategoryReviewEditorHandler, elements: CategoryReviewEditorListenerElements) {
        this.handler = handler;
        this.elements = elements;
        this.categoryEditorHandler = new CategoryEditorHandler(handler);
        this.reviewConfigEditorHandler = new ReviewConfigEditorHandler(handler);
        this.categoryEditorListener = new CategoryEditorListener(this.categoryEditorHandler, elements);
        this.reviewConfigEditorListener = new ReviewConfigEditorListener(this.reviewConfigEditorHandler, elements);
    }

    public register(): void {
        this.categoryEditorListener.register();
        this.reviewConfigEditorListener.register();
    }
}
